/* Ashram Ananda: product page + quick add. No dependencies. */
(function(){
  'use strict';
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var $=function(s,el){return (el||document).querySelector(s)};
  var $$=function(s,el){return Array.prototype.slice.call((el||document).querySelectorAll(s))};

  /* ---------- money ---------- */
  var MONEY_FMT=(function(){var el=$('[data-money-format]');return el?el.dataset.moneyFormat:'${{amount}}'})();
  function money(cents,fmt){
    fmt=fmt||MONEY_FMT;var n=(cents||0)/100;
    var m=fmt.match(/\{\{\s*(\w+)\s*\}\}/), key=m?m[1]:'amount';
    function fix(d,th,dec){var p=n.toFixed(d).split('.');p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,th);return p[1]?p[0]+dec+p[1]:p[0]}
    var v;
    switch(key){
      case 'amount_no_decimals':v=fix(0,',','.');break;
      case 'amount_with_comma_separator':v=fix(2,'.',',');break;
      case 'amount_no_decimals_with_comma_separator':v=fix(0,'.',',');break;
      case 'amount_with_apostrophe_separator':v=fix(2,"'",'.');break;
      default:v=fix(2,',','.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/,v);
  }

  /* ---------- toast ---------- */
  var toastEl,tt;
  function toast(msg){
    if(!toastEl){toastEl=document.createElement('div');toastEl.className='aa-toast';toastEl.setAttribute('role','status');toastEl.setAttribute('aria-live','polite');document.body.appendChild(toastEl)}
    toastEl.textContent=msg;toastEl.classList.add('is-on');clearTimeout(tt);tt=setTimeout(function(){toastEl.classList.remove('is-on')},2400);
  }

  /* ---------- add to cart ----------
     Works with Dawn-style themes (cart drawer / cart notification). If the theme has neither,
     it sends the shopper to the cart page. */
  function addToCart(form,btn){
    var fd=new FormData(form);
    var cartEl=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
    var canRender=cartEl&&typeof cartEl.renderContents==='function'&&typeof cartEl.getSectionsToRender==='function';
    if(canRender){
      fd.append('sections',cartEl.getSectionsToRender().map(function(s){return s.id}));
      fd.append('sections_url',window.location.pathname);
      if(typeof cartEl.setActiveElement==='function')cartEl.setActiveElement(document.activeElement);
    }
    var label=btn?btn.innerHTML:'';
    if(btn){btn.disabled=true;btn.setAttribute('aria-busy','true');btn.textContent='Adding…'}
    return fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){return r.json()})
      .then(function(res){
        if(res.status){throw new Error(res.description||res.message||'Couldn’t add that to your cart.')}
        document.dispatchEvent(new CustomEvent('aa:cart-added',{detail:res}));
        if(canRender){
          if(cartEl.classList.contains('is-empty'))cartEl.classList.remove('is-empty');
          cartEl.renderContents(res);
          toast('Added to cart');
        }else{
          window.location.href=root+'cart';
        }
        return res;
      })
      .finally(function(){if(btn){btn.disabled=false;btn.removeAttribute('aria-busy');btn.innerHTML=label}});
  }

  /* quick add on product cards */
  document.addEventListener('submit',function(e){
    var f=e.target.closest&&e.target.closest('.aa-quick-add');if(!f)return;
    e.preventDefault();
    addToCart(f,f.querySelector('[type=submit]')).catch(function(err){toast(err.message)});
  });

  /* ---------- product page ---------- */
  $$('[data-aa-product]').forEach(function(sec){
    var variantsEl=$('[data-variants]',sec);
    var variants=variantsEl?JSON.parse(variantsEl.textContent):[];
    var form=$('form.aa-form',sec);
    var idInput=$('[data-variant-input]',sec);
    var addBtn=$('[data-add-btn]',sec);
    var qtyInput=$('[data-qty-input]',sec);
    var errEl=$('[data-error]',sec);
    var nudgeEl=$('[data-nudge]',sec);
    var priceEl=$('[data-price]',sec);
    var bb=$('[data-buybar]',sec), bbPrice=$('[data-bb-price]',sec), bbAdd=$('[data-bb-add]',sec);
    var threshold=parseInt(sec.dataset.threshold||'0',10);
    var code=sec.dataset.code||'', discount=sec.dataset.discount||'';
    var current=variants.find(function(v){return idInput&&String(v.id)===idInput.value})||variants[0];

    /* gallery */
    function showMedia(id){
      if(!id)return;
      var found=false;
      $$('.aa-slide',sec).forEach(function(s){var on=s.dataset.mediaId===String(id);s.hidden=!on;if(on)found=true});
      if(!found){var first=$('.aa-slide',sec);if(first)first.hidden=false}
      $$('[data-thumb]',sec).forEach(function(t){t.setAttribute('aria-pressed',String(t.dataset.thumb===String(id)))});
      $$('.aa-slide video',sec).forEach(function(v){if(v.closest('.aa-slide').hidden)v.pause()});
    }
    sec.addEventListener('click',function(e){var t=e.target.closest('[data-thumb]');if(t)showMedia(t.dataset.thumb)});

    /* options */
    function selected(){
      var out=[];
      $$('.aa-option',sec).forEach(function(fs,i){var b=$('[aria-pressed="true"]',fs);out[i]=b?b.dataset.value:null});
      return out;
    }
    function markAvailability(sel){
      $$('.aa-chip[data-option-index]',sec).forEach(function(chip){
        var i=+chip.dataset.optionIndex, test=sel.slice();test[i]=chip.dataset.value;
        var ok=variants.some(function(v){return v.available&&v.options.every(function(o,k){return o===test[k]})});
        chip.classList.toggle('is-unavailable',!ok);
      });
    }
    function render(v,fromUser){
      current=v;
      if(errEl){errEl.hidden=true;errEl.textContent=''}
      if(!v){
        if(addBtn){addBtn.disabled=true;addBtn.textContent='Unavailable'}
        if(bbAdd)bbAdd.disabled=true;
        return;
      }
      if(idInput)idInput.value=v.id;
      var cmp=v.compare_at_price&&v.compare_at_price>v.price;
      if(priceEl)priceEl.innerHTML='<span class="aa-now">'+money(v.price)+'</span>'+(cmp?'<s>'+money(v.compare_at_price)+'</s><span class="aa-save">Save '+money(v.compare_at_price-v.price)+'</span>':'');
      var badge=$('[data-save-badge]',sec);
      if(badge){if(cmp){badge.hidden=false;badge.textContent='Save '+Math.floor((v.compare_at_price-v.price)*100/v.compare_at_price)+'%'}else badge.hidden=true}
      if(bbPrice)bbPrice.innerHTML=money(v.price);
      updateAddLabel();
      if(bbAdd){bbAdd.disabled=!v.available;bbAdd.textContent=v.available?((addBtn&&addBtn.dataset.label)||'Add to cart'):'Full'}
      if(v.featured_media)showMedia(v.featured_media.id);
      if(fromUser)try{var u=new URL(window.location.href);u.searchParams.set('variant',v.id);history.replaceState(history.state,'',u.toString())}catch(e){}
      nudge();
    }
    function updateAddLabel(){
      if(!addBtn||!current)return;
      var q=Math.max(1,parseInt(qtyInput&&qtyInput.value,10)||1);
      addBtn.disabled=!current.available;
      addBtn.textContent=current.available?(addBtn.dataset.label||'Add to cart')+' · '+money(current.price*q):(addBtn.dataset.label==='Book'?'Full':'Sold out');
    }
    sec.addEventListener('click',function(e){
      var chip=e.target.closest('.aa-chip[data-option-index]');if(!chip)return;
      var fs=chip.closest('.aa-option');
      $$('.aa-chip',fs).forEach(function(c){c.setAttribute('aria-pressed',String(c===chip))});
      var lbl=$('[data-option-label="'+chip.dataset.optionIndex+'"]',sec);if(lbl)lbl.textContent=chip.dataset.value;
      var sel=selected();
      markAvailability(sel);
      render(variants.find(function(v){return v.options.every(function(o,k){return o===sel[k]})}),true);
    });
    if($('.aa-option',sec))markAvailability(selected());

    /* quantity */
    sec.addEventListener('click',function(e){
      var s=e.target.closest('[data-qty-step]');if(!s||!qtyInput)return;
      var n=Math.min(99,Math.max(1,(parseInt(qtyInput.value,10)||1)+parseInt(s.dataset.qtyStep,10)));
      qtyInput.value=n;updateAddLabel();nudge();
    });
    if(qtyInput)qtyInput.addEventListener('input',function(){updateAddLabel();nudge()});

    /* submit */
    if(form)form.addEventListener('submit',function(e){
      e.preventDefault();
      if(!current||!current.available)return;
      addToCart(form,addBtn).then(function(){cartTotal=null;nudge()}).catch(function(err){
        if(errEl){errEl.textContent=err.message;errEl.hidden=false}else toast(err.message);
        updateAddLabel();
      });
    });

    /* discount nudge */
    var cartTotal=null;
    function nudge(){
      if(!nudgeEl||!threshold||!current)return;
      var run=function(total){
        var q=Math.max(1,parseInt(qtyInput&&qtyInput.value,10)||1), next=total+current.price*q;
        var deal=discount+(code?' with '+code:'');
        nudgeEl.innerHTML= total>=threshold ? '<span class="aa-ok">Your cart qualifies for '+deal+'.</span>'
          : next>=threshold ? '<span class="aa-ok">Adding this unlocks '+deal+'.</span>'
          : 'With this, you’re '+money(threshold-next)+' away from '+deal+'.';
      };
      if(cartTotal!==null)return run(cartTotal);
      fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){cartTotal=c.total_price||0;run(cartTotal)}).catch(function(){});
    }
    document.addEventListener('aa:cart-added',function(){cartTotal=null;nudge()});
    nudge();

    /* sticky mobile add bar */
    if(bb&&addBtn&&'IntersectionObserver' in window){
      var addSeen=true,footSeen=false,foot=document.querySelector('footer');
      var set=function(){var on=!addSeen&&!footSeen;bb.classList.toggle('is-on',on);bb.setAttribute('aria-hidden',String(!on));document.body.classList.toggle('aa-bb',on)};
      var io=new IntersectionObserver(function(es){es.forEach(function(en){
        if(en.target===foot)footSeen=en.isIntersecting;
        else addSeen=en.isIntersecting||en.boundingClientRect.top>0;
      });set()});
      io.observe(addBtn);if(foot)io.observe(foot);
      bbAdd.addEventListener('click',function(){
        if(form&&form.requestSubmit)form.requestSubmit(addBtn);else addBtn.click();
      });
    }

    /* recently viewed */
    var KEY='aa-recent', handle=sec.dataset.handle, list=[];
    try{list=JSON.parse(localStorage.getItem(KEY)||'[]')}catch(e){}
    var prev=list.filter(function(h){return h!==handle}).slice(0,4);
    try{localStorage.setItem(KEY,JSON.stringify([handle].concat(prev).slice(0,8)))}catch(e){}
    var recent=$('[data-recent]',sec), grid=$('[data-recent-grid]',sec);
    if(recent&&grid&&prev.length){
      Promise.all(prev.map(function(h){return fetch(root+'products/'+encodeURIComponent(h)+'.js').then(function(r){return r.ok?r.json():null}).catch(function(){return null})}))
      .then(function(items){
        items=items.filter(Boolean);if(!items.length)return;
        grid.innerHTML=items.map(card).join('');recent.hidden=false;
      });
    }
    function esc(s){return String(s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
    function card(p){
      var img=p.featured_image?p.featured_image+(p.featured_image.indexOf('?')>-1?'&':'?')+'width=600':'';
      var cmp=p.compare_at_price&&p.compare_at_price>p.price;
      var save=cmp?Math.floor((p.compare_at_price-p.price)*100/p.compare_at_price):0;
      return '<div class="aa-card"><a class="aa-card__art" href="'+esc(p.url)+'" style="background:#ECE7F3" tabindex="-1" aria-hidden="true">'+
        (!p.available?'<span class="aa-badge aa-badge--out">Sold out</span>':save?'<span class="aa-badge">Save '+save+'%</span>':'')+
        (img?'<img src="'+esc(img)+'" alt="" loading="lazy">':'')+'</a>'+
        '<h3><a href="'+esc(p.url)+'">'+esc(p.title)+'</a></h3>'+
        '<div class="aa-price"><span class="aa-now">'+(p.price_varies?'From ':'')+money(p.price)+'</span>'+(cmp?'<s>'+money(p.compare_at_price)+'</s>':'')+'</div></div>';
    }

    if(current)render(current,false);
  });
})();
